/*
akhila 10/27/2022 2701012930  bre UX Changes
suresh peddavoora 10/28/2022 2701012930  Added classname  for dashboard page
ashraf 10/30/2022 2701012930 conditional tabs render
Prakash 11/23/2022  2701012930  Removed card component.
sai krishna  1/3/2023  2701012930 formula rule changed to data calculations
*/

import React, {useState} from 'react';
import Tabs from './Tabs';
import LandingPage from '../../../Pages/LandingPage';

function Bre() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Data Calculation Group', 'Filter Rule Group'];
  return (
    <>
      <LandingPage title={'Frameworks'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}/>
      <div className={`col-md-12 global-field-dash-board`}>
        <div>
          <Tabs value={value} setValue={setValue}/>
        </div>
      </div>
    </>
  );
}

export default Bre;
